import { autoinject } from 'aurelia-dependency-injection';
import { I18N } from 'aurelia-i18n';

import { GenericApi } from '~/api/generic-api';

@autoinject
export class FormWithTableApi {
	constructor(protected readonly i18n: I18N) {}

	protected baseApiUrl: string = 'api/';
	private static readonly EMPTY_TABLE_PARAM: string = 'emptyTable';

	/**
	 * getRecordSelectorTableDataApiUrl is used to generate the URL for a table endpoint.
	 * queryParams can be provided to send additional data to an endpoint, such as with the "transaction-centre"
	 * where ticking "Show My Transactions Only" modifies the URL to add filtering query parameters.
	 */
	public getRecordSelectorTableDataApiUrl(
		functionName: string,
		queryParams?: Map<string, string>,
		isEmptyTable?: boolean,
	) {
		let url = this.baseApiUrl + functionName;

		if (queryParams) {
			if (isEmptyTable) {
				queryParams.set(FormWithTableApi.EMPTY_TABLE_PARAM, 'true');
			} else {
				queryParams.delete(FormWithTableApi.EMPTY_TABLE_PARAM);
			}

			if (queryParams.size > 0) {
				const paramsString = GenericApi.getParamsString(
					{},
					[],
					queryParams,
				);
				url += '?' + paramsString;
			}
		}

		return url;
	}
}
